import { ageRequirement } from "../constants/ageRequirement";

export function isUnderAge(
    birthDate: Date | string,
    ageReq: number = ageRequirement,
    today: Date = new Date() // optional input if needed to check on different date
): boolean {
    const dateOfBirth = new Date(birthDate);

    let age = today.getFullYear() - dateOfBirth.getFullYear();

    const hasHadBirthdayThisYear = 
        today.getMonth() > dateOfBirth.getMonth() ||
        (today.getMonth() === dateOfBirth.getMonth() 
         && today.getDate() >= dateOfBirth.getDate()
        );

    if (!hasHadBirthdayThisYear) {
        age--;
    }

    return age < ageReq;
}